import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import {
  IParentHomeworkDetailResponse,
  IParentHomeworkFiltersResponse,
  IParentHomeworkListQueryParams,
  IParentHomeworkListResponse,
  IParentHomeworkSubmitResponse,
  ParentSubmissionFilesByTask,
} from '../../interface/parentHomework.interface';
import { IErrorResponse } from '../../interface/main.interface';
import { homeworkPortalService } from '../../services/homeworkPortal';

export const fetchParentHomeworkList = createAsyncThunk<
  IParentHomeworkListResponse,
  { studentId: string; params?: IParentHomeworkListQueryParams },
  { rejectValue: IErrorResponse }
>('parentHomework/fetch-list', async ({ studentId, params }, { rejectWithValue }) => {
  try {
    const response = await homeworkPortalService.fetchHomeworkList(studentId, params);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IErrorResponse>;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});

export const fetchParentHomeworkFilters = createAsyncThunk<
  IParentHomeworkFiltersResponse,
  string,
  { rejectValue: IErrorResponse }
>('parentHomework/fetch-filters', async (studentId, { rejectWithValue }) => {
  try {
    const response = await homeworkPortalService.fetchHomeworkFilters(studentId);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IErrorResponse>;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});

export const fetchParentHomeworkDetail = createAsyncThunk<
  IParentHomeworkDetailResponse,
  { homeworkId: string; studentId: string },
  { rejectValue: IErrorResponse }
>('parentHomework/fetch-detail', async ({ homeworkId, studentId }, { rejectWithValue }) => {
  try {
    const response = await homeworkPortalService.fetchHomeworkDetail(homeworkId, studentId);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IErrorResponse>;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});

export const submitParentHomework = createAsyncThunk<
  IParentHomeworkSubmitResponse,
  {
    homeworkId: string;
    studentId: string;
    filesByTask: ParentSubmissionFilesByTask;
  },
  { rejectValue: IErrorResponse }
>('parentHomework/submit', async ({ homeworkId, studentId, filesByTask }, { rejectWithValue }) => {
  try {
    const response = await homeworkPortalService.submitHomework(homeworkId, studentId, filesByTask);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<IErrorResponse>;
    if (!error.response) {
      throw err;
    }
    return rejectWithValue(error.response.data);
  }
});

export const parentHomeworkActions = {
  fetchParentHomeworkList,
  fetchParentHomeworkFilters,
  fetchParentHomeworkDetail,
  submitParentHomework,
};
